<template>
    <div class="columnas">
        <ul v-if="estructura && estructura.length">
            
            <li>
                <div class="fila fila-header " :style="{width: `calc(((100% / ${$attrs.cols.length + 1}) - 1rem) - 2px)`}"></div>
                <div 
                    class="fila fila-header fila-input ellipsis"
                    :style="{width: `calc(((100% / ${$attrs.cols.length + 1}) - 1rem) - 2px)`}"
                    v-for="(col,c) in $attrs.cols" 
                    :key="c">
                    <p class="ellipsis">{{col}}</p>
                </div>
            </li>
            
            <li v-for="(objects, i) in estructura" :key="i">
                <div class="fila ellipsis" :style="{width: `calc(((100% / ${objects.length + 1}) - 1rem) - 2px)`}">
                    <p class="ellipsis">{{objects.find(f => f && f.title).title}}</p>
                </div>
                <div class="fila-inputs">
                    <div
                    v-for="(input,s) in objects"
                    :key="s"
                    :class="['fila', 'fila-input', {'fila-input-empty': !input.order}]"
                    :style="{width: `calc(((100% / ${objects.length}) - 1rem) - 2px)`}"
                    v-loading="input.loading">
                        <InputSigarus
                            v-if="input.order"
                            :busy.sync="input.loading"
                            style="width: 100%;"
                            ref="input"
                            :siblings="inputList"
                            v-show="input.hasOwnProperty('visible') && input.visible"
                            :identificador="id"
                            :entidad="entidad"
                            :input="input"
                            :saveUrl="`${apiUrl.backend}input`"
                            :type="input.format" 
                            :required="!!input.obligatorio"
                            :value="input.format == 'datepicker' ? ['0000-00-00',null,'',undefined].includes(input.value) ? '' : moment(input.value,'YYYY-MM-DD').format('DD/MM/yyyy') : input.value"
                            :placeholder="input.placeholder"
                            :readonly="input.state == 'read-only'"
                            :textPre="input.textpre"
                            :textPos="input.textpos"
                            :options="input.options"
                            @input="val => $emit('input', {newvalue: input.format == 'datepicker' ? moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD') : val, input})"
                            @saved="val => $emit('saved', val)"
                        />
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import InputSigarus from '@/components/inputs/InputSigarus.vue'

import { getUrl } from '@/helpers/api'

import moment from 'moment'

export default {
    name: 'Columnas',
    props: {
        ficha: {
            type: Object,
            required: false,
            default: () => null
        },
        entidad: String,
        id: [Number,String],
        objects: {
            type: Array,
            required: false,
            default: () => null
        },
        porlet: {
            type: Object
        },
        inputList: Array
    },
    components: {
        InputSigarus
    },
    created() {
        this.$nextTick(() => {
            this.$emit('refsInputs', this.$refs.input.filter(input => !['hidden:id'].includes(input.type) && !input.readonly && !input.visible ))
        })
    },
    data() {
        return {
            moment,
            autosave: true,
            cols: this.$attrs.cols.length,
            loading: false,
            apiUrl: getUrl()
        }
    },
    computed: {
        estructura() {

            let total_objects = this.objects.length // Campos a recorrer
            let filas_objects = 0  // Campos ya incluidos en filas
            let col_index = 0 // Indice de fila
            let celda = 1 // Numero de celda

            let items = []
            
            const _generarFila = () => {

                if(!items[col_index]) items[col_index] = []

                for(let i = 0; i < this.cols; i++) {

                    let object = this.objects.find(f => f.order == celda)
                    if(object) {
                        items[col_index].push(object)
                        filas_objects++
                    } else {
                        items[col_index].push({})
                    }

                    celda++
                }

                if (filas_objects < total_objects) {
                    col_index++
                    _generarFila()
                }
            }

            _generarFila()

            return items
        }
    }
}
</script>

<style lang="scss">
.columnas {
    //display: flex;
    ul {
        display: flex;
        flex-flow: column;
        list-style: none;
        margin: 0px;
        padding: 0px;
        li {
            display: flex;
            flex-flow: row;
            border-bottom: 1px solid #e9e9eb;
            .fila {
                width: 150px;
                flex-shrink: 0;
                background-color: #fafafa;
                border-right: 1px solid #e9e9eb;
                padding: 0rem 0.50rem;
                display: flex;
                align-items: center;
                
                &.fila-input {
                    flex-grow: 1;
                    justify-content: center;
                    align-items: center;
                    background-color: white;
                    padding: 0px;
                }
                &.fila-header {
                    background-color: #c9c9c9;
                    > p {
                        padding: 0.5rem;
                        font-weight: 700;
                    }
                }
                p {
                    margin: 0;
                    font-size: .8rem;
                    color: #0000009c;
                }
            }
            .fila-inputs {
                flex-grow: 1;
                display: flex;
            }
        }
    }
    /*table {
        flex-grow: 1;
        border-spacing: 0px;
        border-collapse: collapse;
        thead {
            .columna {
                background-color: #afbac7;
                border: 1px solid #e9e9eb;
                font-size: .8rem;
                color: #0000009c;
                p {
                    padding: 0.50rem 0.50rem;
                    margin: 0px;
                    font-weight: 700;
                }
            }
        }
        tbody {
            .fila {
                background-color: #fafafa;
                border: 1px solid #e9e9eb;
                padding: 0rem 0.50rem;
                margin: 0px;
                font-size: .8rem;
                color: #0000009c;
                p {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin: 0px;
                }
            }
            .fila-input {
                border: 1px solid #e9e9eb;
                &.fila-input-empty {
                    background-color: #afbac71f;
                }
            }
        }
    }*/
}
</style>